import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon, ArrowUpRightIcon, CheckIcon } from 'lucide-react';
import { ProductCard } from '../components/shared/ProductCard';
import { products } from '../data/products';
export function ProductDetail() {
  const {
    slug
  } = useParams();
  const product = products.find(item => item.slug === slug);
  if (!product) {
    return <section className="bg-ink py-32" data-id="element-348" data-mp="13a3nb9zlw7r9">
        <div className="mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-349" data-mp="13b50bk06n4bm">
          <h1 className="font-display text-6xl font-bold uppercase text-chalk md:text-8xl" data-id="element-350" data-mp="yivg8klr0yh9">Product not found</h1>
          <p className="mt-4 text-lg text-muted" data-id="element-351" data-mp="tktu1qt10j1k">This product may have moved. Browse the full range instead.</p>
          <Link to="/products" className="mt-8 inline-flex h-14 items-center gap-2 rounded-full bg-flame px-8 font-bold uppercase text-ink transition-colors duration-150 hover:bg-chalk" data-id="element-352" data-mp="pk08v56yxicd">
            View All Products
          </Link>
        </div>
      </section>;
  }
  const related = products.filter(item => item.category === product.category && item.slug !== product.slug).slice(0, 3);
  return <>
      <section className="bg-ink" data-id="element-353" data-mp="3awdyhea1k1uz">
        <div className="mx-auto max-w-[1320px] px-5 pb-24 pt-10 md:px-8 md:pb-32" data-id="element-354" data-mp="3axfdtuy3baii">
          <Link to="/products" className="group inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.1em] text-muted transition-colors duration-150 hover:text-flame" data-id="element-355" data-mp="3fw0a5ja81a1o">
            <ArrowLeftIcon className="h-4 w-4 transition-transform duration-150 ease-out-strong group-hover:-translate-x-0.5" aria-hidden="true" data-id="element-356" data-mp="bfxvc36yfz3x" />
            All products
          </Link>

          <div className="mt-8 grid gap-12 lg:grid-cols-12 lg:gap-14" data-id="element-357" data-mp="2ehizpwkxmx2">
            <div className="lg:col-span-7" data-id="element-358" data-mp="2i6x9yrpjl541">
              <div className="relative overflow-hidden rounded-[28px] lg:sticky lg:top-28" data-id="element-359" data-mp="2i99qr1jkd9fi">
                <img src={product.image} alt={`${product.name} at Universal Packaging Industries, Umm Al Quwain`} className="aspect-[4/3] w-full object-cover" data-id="element-360" data-mp="2n7l25gpibrzu" />
              </div>
            </div>

            <div className="text-center lg:col-span-5 lg:text-left" data-id="element-361" data-mp="1uatnp5oeoz3q">
              <h1 className="font-display text-5xl font-bold uppercase leading-[0.9] text-chalk sm:text-6xl md:text-7xl" data-id="element-362" data-mp="1pd0h4bj6y32x">
                {product.name}
              </h1>
              <p className="mt-5 text-xl font-semibold text-flame" data-id="element-363" data-mp="1kbkx8msr22m4">{product.line}</p>
              <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-364" data-mp="1fd9lu7mt3k1s">{product.text}</p>

              <h2 className="mt-10 text-sm font-bold uppercase tracking-[0.12em] text-chalk" data-id="element-365" data-mp="1bdj0ijg1tw4n">Variants</h2>
              <ul className="mt-3 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-366" data-mp="16fha1dgamuj5">
                {product.variants.map(variant => <li key={variant} className="rounded-full border border-edge bg-coal px-4 py-2 text-sm font-medium text-chalk" data-id="element-367" data-mp="30s71zpn3ptnw">
                    {variant}
                  </li>)}
              </ul>

              <div className="mt-10 rounded-[28px] bg-flame p-6 text-ink md:p-8" data-id="element-368" data-mp="3d9rjnp697ut2">
                <h2 className="font-display text-3xl font-bold uppercase leading-none" data-id="element-369" data-mp="3i0q2owimn700">What to send us</h2>
                <ul className="mt-5 text-left" data-id="element-370" data-mp="3n0uo90ye6rx3">
                  {product.sendUs.map(item => <li key={item} className="flex items-center gap-3 border-b border-ink/15 py-3 font-medium last:border-b-0" data-id="element-371" data-mp="2pddrtjltwnmj">
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ink text-flame" data-id="element-372" data-mp="2uc76vggrkmot">
                        <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-373" data-mp="2zcuxi112z1ii" />
                      </span>
                      {item}
                    </li>)}
                </ul>
                <Link to={`/contact?product=${product.slug}`} className="mt-7 inline-flex h-14 w-full items-center justify-center gap-2 rounded-full bg-ink font-bold uppercase tracking-[0.06em] text-chalk transition-colors duration-150 hover:bg-coal" data-id="element-374" data-mp="emlye0n98f8m">
                  Request a Quote
                  <ArrowUpRightIcon className="h-5 w-5 text-flame" aria-hidden="true" data-id="element-375" data-mp="r3ofircppg02" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {related.length > 0 && <section className="border-t border-edge bg-coal py-20 md:py-24" aria-labelledby="related-heading" data-id="element-376" data-mp="102iir0kjt4ml">
          <div className="mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-377" data-mp="v478wpu96u4d">
            <h2 id="related-heading" className="font-display text-5xl font-bold uppercase leading-none text-chalk" data-id="element-378" data-mp="19u62efav5hdi">
              More in <span className="text-flame" data-id="element-379" data-mp="14vuu4907vexe">{product.category}</span>
            </h2>
            <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-380" data-mp="1itjbv7yzm5y8">
              {related.map(item => <ProductCard key={item.slug} product={item} data-id="element-381" data-mp="1eu0xkv1o8t4d" />)}
            </div>
          </div>
        </section>}
    </>;
}